var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-editor"}},[_c('Header',{attrs:{"id":"header","pageId":_vm.id}}),_c('SideNav',{attrs:{"id":"sidenav"}}),_c('PageEditor'),(_vm.overlay.component)?_c('Overlay'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }